import axios from '../axios';

export const getChartsDateWarningList = (data) => {
  return axios({
    url: '/con/data/w/getDateWarningList',
    method: 'POST',
    data
  })
}

export const getDateWarningDetail = (data) => {
  return axios({
    url: '/con/data/w/getDateWarningDetail',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dayWarning.js